import { privateRequest, type ApiResponse } from "../axios";

const ENDPOINTS = {
    EXPENSE_ADMIN_CLAIMS: "api/Expense/AdminClaims",
    EXPENSE_REPORT: "api/Expense/Report",
    EXPENSE_APPROVAL: "api/Expense/Report/Approve",
    EXPENSE_CATEGORY: "api/Expense/Category",
    EXPENSE_MY_CLAIM: "api/Expense/v1/Report",
    EXPENSE_EDIT_CLAIM: "api/Expense/UpdateReport",
    EXPENSE_SLAB_VALIDATION: "api/Expense/ExpenseSlabValidation",
    EXPENSE_TAKE_ACTION: "api/Expense/Report/Approve",
    EXPENSE_EXPORT: "api/Expense/ExportToExcel",
    EXPENSE_DELETE: "api/Expense/DeleteReport",
    EXPENSE_CATEGORY_LIST: "api/Expense/ExpenseCategory",
};

export const getExpenseAdminClaims = async (payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.EXPENSE_ADMIN_CLAIMS, { params: payload });
    return res.data;
}

export const getExpenseMyClaims = async (payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.EXPENSE_MY_CLAIM, { params: payload });
    return res.data;
}

export const getExpenseReport = async (id: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(`${ENDPOINTS.EXPENSE_REPORT}/${id}`);
    return res.data;
}

export const approval = async (payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(`${ENDPOINTS.EXPENSE_APPROVAL}`, payload);
    return res.data;
}

export const getCategory = async (): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(`${ENDPOINTS.EXPENSE_CATEGORY}`);
    return res.data;
}

export const getHistory = async (id: number): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(`${ENDPOINTS.EXPENSE_REPORT}/${id}/History`);
    return res.data;
}

export const addClaim = async (payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(`${ENDPOINTS.EXPENSE_REPORT}`, payload);
    return res.data;
}

export const editClaim = async (payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(`${ENDPOINTS.EXPENSE_EDIT_CLAIM}`, payload);
    return res.data;
}

export const getExpenseSlabValidation = async (payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.EXPENSE_SLAB_VALIDATION, { params: payload });
    return res.data;
}

export const takeAction = async (payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(`${ENDPOINTS.EXPENSE_TAKE_ACTION}`, payload);
    return res.data;
}

export const expenseExport = async (payload: any) => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.EXPENSE_EXPORT, { params: payload, responseType: "arraybuffer" });
    return res;
}

export const expenseDelete = async (payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.delete<ApiResponse<any>>(ENDPOINTS.EXPENSE_DELETE, { params: payload });
    return res.data;
}

export const getExpenseCategory = async (payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.EXPENSE_CATEGORY_LIST, { params: payload });
    return res.data;
}

const ExpenseService = {
    getExpenseAdminClaims,
    getExpenseReport,
    approval,
    getCategory,
    getExpenseMyClaims,
    getHistory,
    addClaim,
    editClaim,
    getExpenseSlabValidation,
    takeAction,
    expenseExport,
    expenseDelete,
    getExpenseCategory
}

export default ExpenseService;